import { useRef } from 'react';
import classNames from 'classnames';
import { DeleteOutline } from '@mui/icons-material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { BodySmallText, BodyText } from '../../typography/typography';
import Radio from '../../radio/radio';
import AlxButton from '../../alx-components/button';
import { toIconProp } from '../../../services/icon-utils';
import { icons } from '../../../assets/icons/icons';
import { IRadioCardProps } from './radio-card-types';
import { RadioCardStyle } from './radio-card-style';

const RadioCard: React.FC<IRadioCardProps> = ({
  selectedValue,
  data,
  children,
  actions,
  'data-cy': dataCy,
  ...props
}) => {
  // TO DO
  const radioRef = useRef<any>(null);
  const iconProp = toIconProp(data.icon);
  return (
    <RadioCardStyle
      data-cy={dataCy}
      className={classNames({
        active: selectedValue,
      })}
      onClick={(event: any) => {
        event.stopPropagation();
        event.preventDefault();
        if (props.onClick) {
          props.onClick(event);
        }
      }}
    >
      <div className="radio-card-top">
        {actions && (
          <div className="radio-card-top__actions">
            {actions.close && (
              <div
                data-cy="card-close-button"
                className="radio-card-top__actions__item"
                onClick={() => actions.close?.()}
              >
                <img src={icons.closeIcon} alt="close" />
              </div>
            )}
            {actions.edit && (
              <AlxButton
                data-cy="card-edit-button"
                className="radio-card-top__actions__item ghost"
                onClick={() => actions.edit?.()}
              >
                <img src={icons.editIcon} alt="ecit" />
              </AlxButton>
            )}
            {actions.delete && (
              <AlxButton
                data-cy="card-delete-button"
                className="radio-card-top__actions__item radio-card-top__actions__item--delete ghost"
                onClick={() => actions.delete?.()}
              >
                <DeleteOutline color="error" />
              </AlxButton>
            )}
          </div>
        )}
        <div className="radio-card-left">
          <Radio {...props} inputRef={radioRef} value={data.value} active={!!selectedValue} />
        </div>
        <div className="radio-card-icon">{iconProp && <FontAwesomeIcon icon={iconProp} size="lg" />}</div>
        <div className="radio-card-right">
          <div className="radio-card-right__title">
            <BodyText weight={600}>{data.title}</BodyText>
          </div>
          {data.text && (
            <div className="radio-card-right__text">
              {Array.isArray(data.text) ? (
                data.text.map((text, index) => <BodySmallText key={index}>{text}</BodySmallText>)
              ) : (
                <BodySmallText>{data.text}</BodySmallText>
              )}
            </div>
          )}
        </div>
      </div>
      {children && <div className="radio-card-children">{children}</div>}
    </RadioCardStyle>
  );
};

export default RadioCard;
